import { render, staticRenderFns } from "./ExportTasks.vue?vue&type=template&id=2b03f6c0"
import script from "./ExportTasks.vue?vue&type=script&lang=js"
export * from "./ExportTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports